<template>
  <div></div>
</template>

<script>
/*
  This component abstracts an alert (toast) message for problem that arises in the authentication process
*/

import { mapGetters } from 'vuex'

export default {
  mounted () {
    // clear existing status message
    this.$store.dispatch('auth/clearAuthenticationStatus')
  },
  computed: {
    ...mapGetters('auth', ['authenticationStatus', 'hasAuthenticationStatus'])
  },
  watch: {
    hasAuthenticationStatus () {
      // only run if there is a problem in the authentication process
      if (this.hasAuthenticationStatus) {
        // show a toast with the information of the problem
        this.$bvToast.toast(this.authenticationStatus.message, {
          title: 'Problema durante l\'accesso',
          autoHideDelay: 4000,
          appendToast: false,
          variant: this.authenticationStatus.variant,
          solid: true
        })
      }
    }
  }
}
</script>
